import makeApiRequest from './makeApiRequest'

const apiRequest = makeApiRequest()

export const getListSku = (filters) => {
    return apiRequest({
        url: 'sku/search',
        method: 'POST',
        data: filters
    })
}

export const addSku = async (payload) => {
    return apiRequest({
        url: `/sku`,
        method: 'POST',
        data: payload
    })
}

export const editSku = async (id, payload) => {
    return apiRequest({
        url: `/sku/${id}`,
        method: 'PUT',
        data: payload
    })
}

export const deleteSku = async (id) => {
    return apiRequest({
        url: `/sku/${id}`,
        method: 'DELETE',
    })
}

export const bulkDeleteSku = (data) => {
    return apiRequest({
        url: '/sku/bulk/delete',
        method: 'DELETE',
        data: data
    })
}

export const bulkUpdateStatus = (data) => {
    return apiRequest({
        url: '/sku/bulk/update-status',
        method: 'PUT',
        data: data
    })
}

export const getInfoSku = (id) => {
    return apiRequest({
        url: `/sku/${id}`,
        method: 'GET'
    })
}

export const getSkuSizes = (id) => {
    return apiRequest({
        url: `/sku/${id}/sizes`,
        method: 'GET'
    })
}

export const getSkuSizesShippingCarrier = (id, payload = {}) => {
    return apiRequest({
        url: `/sku/${id}/sizes/shipping-carrier`,
        method: 'POST',
        data: payload
    })
}

export const deleteSizesSkuShippingCarrier = (id, shippingCarrier) => {
    return apiRequest({
        url: `/sku/${id}/shipping-carrier`,
        method: 'DELETE',
        data: shippingCarrier
    })
}

export const addSkuSize = (id, payload) => {
    return apiRequest({
        url: `/sku/${id}/sizes`,
        method: 'POST',
        data: payload
    })
}

export const updateSkuSize = (skuID, sizeID, payload) => {
    return apiRequest({
        url: `/sku/${skuID}/sizes/${sizeID}`,
        method: 'PUT',
        data: payload
    })
}

export const deleteSkuSize = (skuID, sizeID) => {
    return apiRequest({
        url: `/sku/${skuID}/sizes/${sizeID}`,
        method: 'DELETE',
    })
}

export const getHistory = (id) => {
    return apiRequest({
        url: `/sku/${id}/histories`,
        method: 'GET'
    })
}

export const updateMaterials = (id, payload) => {
    return apiRequest({
        url: `/sku/${id}/materials`,
        method: 'PUT',
        data: payload
    })
}

export const addShippingCarrierSku = (id, payload) => {
    return apiRequest({
        url: `/sku/${id}`,
        method: 'POST',
        data: payload
    })
}

export const getShippingCarrierSku = (id) => {
    return apiRequest({
        url: `/sku/${id}/shipping-carrier`,
        method: 'GET'
    })
}

export const getListBrandSku = (id) => {
    return apiRequest({
        url: `/sku/${id}/brands`,
        method: 'GET'
    })
}

export const importSkuPrice = (payload) => {
    return apiRequest({
        url: `/base-cost/upload`,
        method: 'POST',
        data: payload
    })
}

export const importMaterial = (payload) => {
    return apiRequest({
        url: `/bulk-material`,
        method: 'POST',
        data: payload
    })
}

export const getListMaterials = (params) => {
    return apiRequest({
        url: `/materials`,
        method: 'GET',
        params
    })
}

export const getListProductionMethods = (params) => {
    return apiRequest({
        url: `/production-method`,
        method: 'GET',
        params
    })
}

export const createMaterial = (data) => {
    return apiRequest({
        url: `/materials/create`,
        method: 'POST',
        data
    })
}

export const updateMaterial = (data, id) => {
    return apiRequest({
        url: `/materials/${id}`,
        method: 'PUT',
        data
    })
}

export const getListProductionProcess = (params) => {
    return apiRequest({
        url: `/production/process`,
        method: 'GET',
        params
    })
}

export const getListProductionStage = (params) => {
    return apiRequest({
        url: `/production/stage`,
        method: 'GET',
        params
    })
}

export const getProductionProcessDetail = (id) => {
    return apiRequest({
        url: `/production/process/${id}`,
        method: 'GET',
    })
}

export const createProductProcess = (data) => {
    return apiRequest({
        url: `/production/process`,
        method: 'POST',
        data
    })
}

export const updateProductProcess = (data, id) => {
    return apiRequest({
        url: `/production/process/${id}`,
        method: 'PUT',
        data
    })
}

export const updateProcessStatus = (id) => {
    return apiRequest({
        url: `/production/processStatus/${id}`,
        method: 'PUT',
    })
}

export const getProductionProcess = (payload) => {
    return apiRequest({
        url: `/production/process`,
        method: 'GET',
        params: payload,
    })
}

export const addNewTabSku = (id, objectType, objectName) => {
    return apiRequest({
        url: `/sku/v2/${id}/sizes/${objectType}/${objectName}/clone`,
        method: 'POST',
    })
}

export const getSkuSizesTab = (id, objectType, objectName) => {
    return apiRequest({
        url: `/sku/v2/${id}/sizes/${objectType}/${objectName}`,
        method: 'GET'
    })
}

export const deleteSizesSkuTab = (id, objectType, objectName) => {
    return apiRequest({
        url: `/sku/v2/${id}/sizes/${objectType}/${objectName}`,
        method: 'DELETE',
    })
}

export const getListTab = (id) => {
    return apiRequest({
        url: `/sku/v2/${id}/sizes/optimization`,
        method: 'GET'
    })
}

export const addSkuSizeV2 = (id, objectType, objectName, payload) => {
    return apiRequest({
        url: `/sku/v2/${id}/sizes/${objectType}/${objectName}`,
        method: 'POST',
        data: payload
    })
}

export const uploadImageSku = (data) => {
    return apiRequest({
        url: `/sku/upload-mockup`,
        method: 'POST',
        data
    })
}

export const getAllProductType = (params) => {
    return apiRequest({
        url: '/sku/product-type',
        method: 'GET',
        params
    })
}

/**
 * Cấu hình cấu trúc layer của SKU.
 * Đọc: dùng luôn getInfoSku (GET /sku/:id) — response đã trả has_layer_config, white_print, layers[].
 */
export const updateSkuLayerConfig = (id, payload) => {
    return apiRequest({
        url: `/sku/${id}/layer-config`,
        method: 'PUT',
        data: payload
    })
}

/* ------------------------------------------------------------------------------------------------
 * Cấu trúc layer NVL của SKU — FEAT-2256 · T8
 * ---------------------------------------------------------------------------------------------- */

/**
 * Đọc Blob thành chuỗi.
 *
 * `Blob.prototype.text()` chỉ có từ Safari 14, mà `browserslist` của repo
 * (`>0.2%, not dead, not ie <= 11`) vẫn bao Safari 12.1–13.1 và iOS 12–13 — CRA không polyfill.
 * Thiếu đường lui thì mọi thông báo lỗi của hai endpoint dưới đây suy biến về câu mặc định.
 * `FileReader` có từ IE10 nên lấy làm đường lui.
 *
 * Chép khuôn từ `blobToText` trong `apiProductionPlanning.js` — hàm đó là const nội bộ, không
 * export nên không import chéo được. 10 dòng trùng lặp đổi lấy việc không phải sửa file của
 * nhóm màn khác.
 */
export const blobToText = (blob) => {
    if (typeof blob.text === 'function') return blob.text()

    return new Promise((resolve, reject) => {
        const reader = new FileReader()

        reader.onload = () => resolve(reader.result)
        reader.onerror = () => reject(reader.error)
        reader.readAsText(blob)
    })
}

/**
 * Gọi một endpoint TRẢ FILE của nhóm layer-config.
 *
 * Hai option, cả hai đều bắt buộc:
 *
 * `responseType: 'blob'` — BE trả CSV stream. Thiếu nó thì axios cố parse thành chuỗi/JSON và
 * file hỏng ở mức im lặng.
 *
 * `validateStatus: () => true` — axios KHÔNG reject ở bất kỳ status nào, nên interceptor lỗi của
 * `makeApiRequest` không bao giờ chạm tới response. Đó chính là điểm phải tránh: interceptor đó
 * làm `{...data}` trên một Blob và cho ra `{}` (`size`/`type` là accessor trên prototype, không
 * phải own enumerable property) ⇒ thân file biến mất. `createApiServices.js` đã vá đúng ca này
 * bằng một guard Blob; `makeApiRequest.js` thì CHƯA — nhưng file đó có 9 service dùng chung nên
 * đi vòng bằng một option tại chỗ gọi, giữ thay đổi nằm gọn trong file này.
 *
 * ⚠️ Đánh đổi: nơi gọi phải TỰ kiểm `response.status`. Quên kiểm thì một cú 403 sẽ được tải
 *    xuống thành file .csv chứa thân JSON lỗi, và người dùng tưởng là xuất thành công.
 *
 * ⚠️ NỢ KỸ THUẬT — cần ticket riêng, KHÔNG sửa ở đây vì ngoài phạm vi task này:
 *    ghi chú trong `createApiServices.js` ("đã rà toàn `src/`: `responseType: 'blob'` chỉ xuất
 *    hiện ở `api/apiProductionPlanning.js`") trở thành SAI kể từ file này. Ai vá guard Blob cho
 *    `makeApiRequest.js` phải sửa kèm câu đó, nếu không người đọc sau sẽ tin vào một phép rà đã
 *    cũ và suy sai về blast radius. Vá xong guard thì `validateStatus` dưới đây bỏ được.
 */
const requestFile = (config) => apiRequest({
    ...config,
    responseType: 'blob',
    validateStatus: () => true,
})

/**
 * Đọc thông báo lỗi nghiệp vụ từ một response trả blob.
 *
 * Trả `null` khi thân không phải JSON (trang lỗi HTML của proxy, body rỗng) để nơi gọi dùng câu
 * tiếng Việt mặc định của mình thay vì hiện một đống HTML.
 */
export const fileErrorMessage = async (response) => {
    try {
        return JSON.parse(await blobToText(response.data)).message || null
    } catch (e) {
        return null
    }
}

/**
 * Bỏ các giá trị rỗng trước khi đẩy lên query string.
 *
 * Bám đúng `SkuPage._fetchListSku`, chỗ nó `delete newFilters.is_active` khi giá trị là `''` —
 * chuỗi rỗng lọt lên BE sẽ bị hiểu là một bộ lọc thật và trả về 0 dòng. Giữ `false` và `0` vì đó
 * là giá trị lọc hợp lệ.
 */
const cleanFilters = (filters = {}) => Object.keys(filters).reduce((acc, key) => {
    const value = filters[key]

    if (value === '' || value === null || value === undefined) return acc
    if (Array.isArray(value) && !value.length) return acc

    return {...acc, [key]: value}
}, {})

/**
 * GET /skus/export/layer-config — xuất cấu trúc layer của các SKU khớp bộ lọc đang áp dụng.
 *
 * Trả về NGUYÊN response axios (không bóc `data`) vì nơi gọi cần `status` để tự phân loại.
 *
 * ⚠️ Chờ T0 chốt: endpoint phải nhận đúng bộ key mà `POST /sku/search` đang nhận
 *    (`name`, `sku`, `is_active`, `procedure`, `partner`, `production_process`,
 *    `has_commitment_time_fast_production`). `sku` là MẢNG — paramsSerializer mặc định của axios
 *    0.19 sinh `sku[]=A&sku[]=B`; nếu BE đọc kiểu khác thì bộ lọc theo mã SKU sẽ im lặng không
 *    có tác dụng và file xuất ra thừa dòng.
 */
export const exportLayerConfig = (filters = {}) => requestFile({
    url: '/skus/export/layer-config',
    method: 'GET',
    params: cleanFilters(filters),
})

/** Trần thời gian cho một lượt nạp file — lý do ở JSDoc ngay bên dưới. */
const IMPORT_TIMEOUT_MS = 5 * 60 * 1000

/**
 * POST /skus/import/layer-config — nạp file cấu trúc layer.
 *
 * Response có HAI hình dạng, phân biệt bằng `Content-Type`:
 *   - `application/json` — mọi dòng hợp lệ, đã ghi đè xong.
 *   - CSV đính kèm       — có ít nhất một dòng lỗi, CHƯA SKU NÀO ĐƯỢC GHI (all-or-nothing).
 * Vì vậy phải đọc blob ở cả hai nhánh, kể cả nhánh thành công.
 *
 * `timeout` dài nhưng HỮU HẠN. BE validate toàn bộ file trước khi ghi nên không đoán trước được
 * thời gian, nhưng `0` (vô hạn) thì hỏng: trong lúc `loading`, modal khoá mọi đường đóng (nền
 * tĩnh, ESC vô hiệu, ẩn dấu X, nút Hủy disabled) để người dùng không mất dấu một thao tác ghi đè
 * đang chạy. Kết nối treo cộng `timeout: 0` sẽ giam người dùng trong modal đó tới tận TCP timeout
 * của hệ điều hành. Mốc hữu hạn đảm bảo modal luôn tự giải phóng.
 *
 * ⚠️ Chờ T0 chốt tên field của multer. Đoán sai thì multer nhận file rỗng và BE báo lỗi kiểu
 *    "thiếu file" thay vì lỗi nghiệp vụ.
 */
export const importLayerConfig = (file) => {
    const formData = new FormData()

    formData.append('file', file)

    return requestFile({
        url: '/skus/import/layer-config',
        method: 'POST',
        data: formData,
        headers: {'Content-Type': 'multipart/form-data'},
        timeout: IMPORT_TIMEOUT_MS,
    })
}
